import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=105537a1&"
import script from "./PageResult.vue?vue&type=script&lang=js&"
export * from "./PageResult.vue?vue&type=script&lang=js&"
import style0 from "./PageResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports